import { createLink } from "@tanstack/react-router";

import { ExpandingArrowLink } from "./expanding-arrow-button";

/** `ExpandingArrowLink` wired into TanStack Router, with the typed `to`/`params`/`search` props of `Link`. */
export const ExpandingArrowRouterLink = createLink(ExpandingArrowLink);
